"use strict";

import getCookie from 'utils/getCookie';
import axios from 'axios';

const SELECTOR = '[data-promo-cookie]';

(function() {
    document.querySelectorAll(SELECTOR).forEach(el => {
        const promoCode = getCookie(el.dataset.promoCookie);

        if (promoCode) {
            el.querySelector(el.dataset.promoDisplaySelector).innerText = promoCode;
            el.classList.add('is-visible');

            let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0); //get viewport width

            if (vw >= 999 ) {
                el.classList.add('sticky-header');
            }

            window.addEventListener('resize', () => {
                let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0); //get viewport width

                if (vw >= 999 ) {
                    el.classList.add('sticky-header');
                } else {
                    el.classList.remove('sticky-header');
                }
            });

            if (el.dataset.promoRemoveSelector && el.dataset.postEndpoint) {
                el.querySelectorAll(el.dataset.promoRemoveSelector).forEach(rmEl => {
                    rmEl.addEventListener('click', ev => {
                        ev.preventDefault();
                        el.classList.add('processing');

                        const basicAuth = el.dataset.basicAuth ? JSON.parse(el.dataset.basicAuth) : false;

                        const options = {
                            withCredentials: true,
                        };
                        const data = new FormData();
                        data.append('promo_code[remove]',  '');
                        data.append('promo_code[promo_code]',  '');
                        data.append('isajax', true);

                        if (basicAuth) {
                            options.auth = {
                                username: basicAuth[0],
                                password: basicAuth[1],
                            }
                        }

                        axios
                            .post(el.dataset.postEndpoint, data, options)
                            .then(() => {
                                el.classList.remove('processing');
                                window.location.reload();
                            });
                        return false;
                    })
                });
            }
        }
    });
}());
